/**
 * All the keys included in the following array will be removed from the
 * attributes of the parsed components.
 */
const AttributeFilters = ['data-template', 'data-component', 'style'];

export default AttributeFilters;
